module.exports = __webpack_public_path__ + "img/epr-article-top-img.33e81ef5.jpg";